import { convertObjectToQueryString } from 'src/utils/functions'
import { GetUserAvatarByUcodeParams } from './types'

export const UserEndpoints = {
  getUserDataByUcode: (ucode?: string) => `/rest/v1/users/${ucode}/profile/summary`,
  getUserPostsByUcode: (ucode?: string) =>
    `${process.env.COMMUNITY_GATEWAY_URL}/v1/users/${ucode}/posts`,
  getUserSessionData: () => '/rest/v2/users/me',
  getUserAvatarByUcode: ({ ucode, options }: GetUserAvatarByUcodeParams) => {
    const queryParams = options ? `?${convertObjectToQueryString(options)}` : ''
    return `${process.env.COMMUNITY_GATEWAY_URL}/public/v1/users/${ucode}/image${queryParams}`
  }
}
